import { render, staticRenderFns } from "./RoomApp.vue?vue&type=template&id=517767a9"
import script from "./RoomApp.vue?vue&type=script&lang=js"
export * from "./RoomApp.vue?vue&type=script&lang=js"
import style0 from "./RoomApp.vue?vue&type=style&index=0&id=517767a9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VIcon,VRow})
